export default {
  "taskAdmin.thead.index": "#NO",
  "taskAdmin.thead.documentId": "DocumentId",
  "taskAdmin.thead.bindSite": "绑定站点",
  "taskAdmin.thead.title": "任务名称",
  "taskAdmin.thead.type": "任务类型",
  "taskAdmin.thead.groupKey": "组键",
  "taskAdmin.thead.rewardCash": "现金奖励",
  "taskAdmin.thead.rewardGem": "宝石奖励",
  "taskAdmin.thead.description": "描述",
  "taskAdmin.thead.target": "目标",
  "taskAdmin.thead.jumpUrl": "跳转Url",
  "taskAdmin.thead.tips": "提示",
  "taskAdmin.thead.params": "额外参数",
  "taskAdmin.thead.img": "图片",
  "taskAdmin.thead.withdrawLimit": "流水倍率",
  "taskAdmin.thead.sort": "排序",
  "taskAdmin.thead.createdAt": "创建时间",
  "taskAdmin.thead.updatedAt": "更新新时间",

  "taskAdmin.add": "新增",
  "taskAdmin.edit": "编辑",
  "taskAdmin.details": "详情",
  "taskAdmin.delete": "删除",
  "taskAdmin.thead.action": "操作",
};
